<template>
  <tr>
    <td style="min-width: 60px;width:250px;text-align: left;padding:0 5px;white-space: normal">
      {{ row.productAlias }}
    </td>
    <td style="min-width: 80px;width:280px;text-align: left;padding:0 5px;white-space: normal">
      {{ row.productName }}
      <!-- 下载SOW按钮 -->
      <a
        class="download-sow-style"
        @click="downloadSowMethods"
        v-if="downloadSowFid !== null && downloadSowFid !== '' "
      >
        {{ $t('exportExcelModule.downloadSOW') }}
      </a>
      <span v-if="!row.industryIsEnabled" class="promotion">
        <img src="../../assets/shelves-new.png" alt="err">
      </span>
      <span v-if="row.quotation===1" class="promotion2">
        <img src="../../assets/fuwushang-new.png" alt="err">
      </span>
      <span v-if="row.quotation===2 && getStore('industryFlg') === 1" class="promotion2">
        <img src="../../assets/fuwushang-new.png" alt="err">
      </span>
    </td>
    <td style="min-width: 120px;width:120px;text-align: right; padding-right: 10px">
      <el-input-number
        size="mini"
        v-model="row.discountRatio "
        :precision="2"
        :min="0"
        @change="handleRatio"
        style="width: 110px"
      />
    </td>
    <td style="min-width: 50px;width:130px;text-align: right;padding-right: 5px">
      {{ productPriceFormat(null,null,row.productPrice) }}
    </td>
    <td style="min-width: 50px;width:130px;text-align: right;padding-right: 5px">
      <span
        v-if=" (row.isSpdc==1) && (!isPartner || isPartner && getStore('partnerAuth') == '1')"
      >
        {{ productPriceFormat(null,null,row.spdcPrice) }}
      </span>
    </td>
    <td style="min-width: 50px;width:130px;text-align: right;padding-right: 5px" v-if="!isPartner">
      <span v-if="row.isDiscount">
        {{ productPriceFormat(null,null,row.promotionPrice) }}
      </span>
    </td>
    <td style="min-width: 50px;width:50px;text-align: right; padding-right: 10px">
      <el-input-number
        size="mini"
        v-model="row.discountPrice"
        @change="handleChange"
        :min="0"
        :precision="2"
      />
    </td>
    <td style="min-width: 50px;width:50px">{{ row.purchaseQuantity * subItem.tcount }}</td>
  </tr>
</template>
<script type="es6">
import { getStore } from '@/utils/mUtils';
import { productPriceFormat } from '@/utils/numberFormater';
import API from  "../../api";
export default {
  data () {
    return {
      downloadSowFid:'',
    };
  },
  components: {},
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    subItem: {
      type: Object,
      default: () => {}
    },
    isPartner: {
      type: Boolean,
      default: true
    }
  },
  computed: {

  },
  methods: {
    productPriceFormat,
    getStore,
    // 折后单价值变化
    handleChange (val) {
      if (val == undefined) {
        this.row.discountPrice = 0;
      }
      this.row.discountRatio = (this.row.discountPrice / this.row.productPrice) * 100;
      // 如果isrill是1价格为0，可以填写折后价格。

      // 填写的价格发生变化目录总价随之发生变化。

      // 总折扣发生变化，rill的折扣价格也发生变化，目录总价发生变化折扣总价变化，总折扣率发生变化
    },
    handleRatio () {
      if (this.row.discountRatio == 0) {
        this.row.discountPrice = 0;
      } else {
        this.row.discountPrice = this.row.productPrice * (this.row.discountRatio / 100);
      }
    },
    useSuggestedDiscount () {
      this.row.discountRatio = this.row.suggestedDiscountRatio;
      this.handleRatio();
    },
    // 下载downloadSowMethods
    downloadSowMethods(){
        let param = {
          params: {
            sow: this.downloadSowFid !== null ? this.row.sow : ''
          }
        };
        API.exportFilesSOW(param).then(res=>{
          let {status,data,err} = res.data;
          if(status === '200'){
            window.open(data.furl);
          }else {
            this.$message.error(err);
          }
        }).catch((err)=>{
          // console.log(err);
        });

      },
    // defaultRatio(){
    //   if(!this.row.discountRatio ||this.row.discountRatio=="" || this.row.discountRatio==null){
    //     this.row.discountRatio=100;
    //     this.row.discountPrice =this.row.productPrice;
    //   }else{
    //     this.row.discountPrice = (this.row.discountRatio / 100) * this.row.productPrice;
    //   }
    // }
  },
  // mounted() {
  //   this.defaultRatio();
  //
  // },
  mounted() {
      this.downloadSowFid=this.row.sow;
    },
  filters: {
    number (value) {
      var toFixedNum = Number(value).toFixed(3);
      var realVal = toFixedNum.substring(0, toFixedNum.toString().length - 1);
      return realVal;
    }
  },
  watch: {
    row: {
      handler (newval) {
      },
      deep: true
    }
  }
};
</script>
<style lang="less">
  .promotion img{
    width: 32px;
    height: 20px;
    vertical-align: middle;
  }

  .download-sow-style{
  margin-left: 30px;
  display: inline-block;
  // width: 80px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  color: #36bae2;
  cursor:pointer;
  border: 1px solid #36bae2;
  border-radius: 2px;
}

  .promotion:hover img{
    width: 35px;
    height: 20px;
    vertical-align: middle;
  }

  .promotion2{
    width: 40px;
    height: 20px;
    display: inline-block;
  }
  .promotion2 img{
    width: 40px;
    height: 20px;
    vertical-align: middle;
  }
  .promotion2:hover img{
    width: 45px;
    vertical-align: middle;
  }
</style>
